import{gql as e}from"@apollo/client";const o=e`
  query getUserFlowAccessMode($groupId: Int!) {
    userFlowAccessMode {
      getUserFlowAccessMode: get(groupId: $groupId) {
        mode
      }
    }
  }
`;export{o as GET_USER_FLOW_ACCESS_MODE_QUERY};
//# sourceMappingURL=useGetUserFlowAccessMode.graphql.js.map
